import { render, staticRenderFns } from "./SurveyQuestionForm.vue?vue&type=template&id=d983ebe6"
import script from "./SurveyQuestionForm.ts?vue&type=script&lang=ts&external"
export * from "./SurveyQuestionForm.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports